module.exports = __webpack_public_path__ + "img/topicEnvironment.fb3049cd.webp";